import { useTranslation } from 'react-i18next'

import { AIButtonContainedLight } from '../../AIButton'

import * as styles from './AIGretaAskButton.module.css'

import StarIcon from '../../../icons/unique/ai/star-3.svg'

function AIGretaAskButton({
  className = styles.aiGretaAskButton,
  disabled,
  isLoading,
  qaName,
  textKey = 'Wizard.AIWizardButtonKey',
  tooltip,
  tooltipPlacement,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <AIButtonContainedLight
      beforeIconProps={{ Icon: StarIcon }}
      className={className}
      disabled={disabled}
      isLoading={isLoading}
      qaName={qaName}
      text={isLoading ? undefined : t(textKey)}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      onClick={onClick}
    />
  )
}

export default AIGretaAskButton
